module.exports = __webpack_public_path__ + "img/04.275e2dac.jpg";